import { StatePaymentSystems } from "@/store/types";

export const state = function(): StatePaymentSystems {
  return {
    systems: [],
  };
};
